// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2ONON","list":"styles_list__2Ye6x"};